import styled from "styled-components";
import colors from "../../utils/constants/COLORS";

export const ErrorStyle = styled.div`
  border-radius: 4px;
  outline: ${(props) =>
    props?.error?.length > 0 ? `solid 2px ${colors.danger}` : null};
`;